var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgUpload = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99994 2.29285L7.64639 2.6464L4.64639 5.6464C4.45112 5.84166 4.45112 6.15825 4.64639 6.35351C4.84165 6.54877 5.15823 6.54877 5.35349 6.35351L7.49994 4.20706V9.49998C7.49994 9.77613 7.7238 9.99998 7.99994 9.99998C8.27608 9.99998 8.49994 9.77613 8.49994 9.49998V4.20706L10.6464 6.35351C10.8416 6.54877 11.1582 6.54877 11.3535 6.35351C11.5488 6.15824 11.5488 5.84166 11.3535 5.6464L8.35349 2.6464L7.99994 2.29285ZM2.99994 8.99998C3.27608 8.99998 3.49994 9.22384 3.49994 9.49998V10.5C3.49994 11.3284 4.17151 12 4.99994 12H10.9999C11.8284 12 12.4999 11.3284 12.4999 10.5V9.49998C12.4999 9.22384 12.7238 8.99998 12.9999 8.99998C13.2761 8.99998 13.4999 9.22384 13.4999 9.49998V10.5C13.4999 11.8807 12.3807 13 10.9999 13H4.99994C3.61923 13 2.49994 11.8807 2.49994 10.5V9.49998C2.49994 9.22384 2.7238 8.99998 2.99994 8.99998Z",
    fill: "#D1D2D3"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgUpload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/upload.992abdce50549ffafe1edf9b0f00b0b9.svg";